import { Component, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";

import { BfxDialogData } from "./models/bfx-dialog-data.model";

import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";

import { OrdersTableDefinitionFactory, TableDefinition } from "shared/cubiq-services";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: `bfx-dialog-order-cancel-confirm`,
  templateUrl: `./html/bfx-dialog-order-cancel-confirm.html`,
  standalone: false,
})
export class BfxDialogOrderCancelConfirmComponent extends BfxDialogBaseComponent {
  public title: string = "";
  public messages: Array<string> = [];
  public tableDefinition: TableDefinition = null;
  public subMessage: string = null;
  public callback: any = null;

  public data: any = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      count: 0,
    },
  };

  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
    ordersTableDefinitionFactory: OrdersTableDefinitionFactory,
    protected element: ElementRef,
  ) {
    super();
    this.tableDefinition = ordersTableDefinitionFactory.createDef();
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      if (_dialogData.payload != null) {
        this.messages = _dialogData.payload.messages;
        this.title = _dialogData.payload.title;
        this.subMessage = _dialogData.payload.subMessage;
      }

      if (this.messages.length > 0) {
        this.title = this.translationService.instant(this.title);
        NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this.element);
        this.data.dialogData.show = true;
      }
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxDialogOrderCancelConfirmComponent.openDialog(): Dialog exception! msg:",
        ex,
      );
    }

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    if (
      this.data != null &&
      this.data.payload != null &&
      typeof this.data.payload.callbackNegative === "function"
    ) {
      this.data.payload.callbackNegative();
    }

    super.closeDialog();
    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.dialogData.message_text_ids = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionConfirmed(): void {
    this.data.payload.callback();
    this.closeDialog();
  }
}
